import { analyseFileName } from './fileHelpers';

export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.avif'];
export const PDF_EXTENSION = '.pdf';
// Must stay equal to MAX_PDF_BYTES in server/api/attachment-pdf.js: a larger PDF cannot be previewed.
export const MAX_PDF_PREVIEW_BYTES = 25 * 1024 * 1024;
const extensionOf = name =>
  typeof name === 'string' ? analyseFileName(name).extension.toLowerCase() : '';
const isAvailable = file => {
  const { state, deleted } = file?.attributes || {};
  return state === 'available' && deleted !== true;
};
/** Only photos and PDFs can be sent (Tara, 25/09/2026). */
export const isAllowedUpload = file =>
  [...IMAGE_EXTENSIONS, PDF_EXTENSION].includes(extensionOf(file?.name));
/** Photo extension, decoded or not: never offered for download. */
export const hasImageExtension = file =>
  IMAGE_EXTENSIONS.includes(extensionOf(file?.attributes?.name));
/** Extensions are candidates only: the browser still has to decode the image. */
export const isPreviewableImage = file => isAvailable(file) && hasImageExtension(file);
/** Decided by extension, like isPreviewablePdf: the extension picks the viewer. */
export const isPdfFileName = name => extensionOf(name) === PDF_EXTENSION;
/** PDFs open in the in-page viewer instead of downloading. */
export const isPreviewablePdf = file => isAvailable(file) && isPdfFileName(file?.attributes?.name);
/** Keep the public attachment IDs and message order. */
export const getMessageImages = (attachments = []) =>
  attachments.filter(a => isPreviewableImage(a.file));
/** The fourth tile opens image four, including when it carries an overflow label. */
export const getMosaicItems = images => ({
  items: images.slice(0, 4),
  extraCount: Math.max(0, images.length - 4),
});
/** Navigation stops at either end. */
export const getNextImageIndex = (index, delta, count) =>
  Math.max(0, Math.min(count - 1, index + delta));
/** Viewers rely on the native modal <dialog> (missing before iOS 15.4). */
export const supportsModalDialog = () =>
  typeof window !== 'undefined' &&
  typeof window.HTMLDialogElement?.prototype?.showModal === 'function';
